import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import Tabs from '@/app/tabs/tabs';

export default function TabsPage() {
  return <Tabs />;
}
